import { createApp } from 'vue';
import App from './App.vue';
import Router from './router.js';
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

import './assets/styles/fonts.css';
import en from './locales/en.json'
import tr from './locales/tr.json'

import HomePage from './pages/HomePage.vue';
import NavigationBar from './components/navbar/NavigationBar.vue';
import AdminNavBar from './components/navbar/AdminNavBar.vue';
import { useLangStore } from './stores/langStore';

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

const langStore = useLangStore();
const i18n = createI18n({
  legacy: false,
  locale: langStore.language,
  fallbackLocale: 'en',
  messages: { en, tr },
});



app.component('home-page', HomePage);
app.component('nav-bar', NavigationBar);
app.component('admin-nav-bar', AdminNavBar);

app.use(Router);

app.use(i18n);

app.mount('#app');